import {
  ERROR_COLOR,
  ERROR_BG,
  ERROR_TEXT,
  WARNING_COLOR,
  WARNING_BG,
  INFO_COLOR,
  SUCCESS_COLOR,
  SUCCESS_BG,
  SUCCESS_TEXT,
} from 'components/upb_viewer_beta/css/betaTokens';

// Ordinal quality tiers for the four match-rate bands (low match -> high match).
export const BAND_TIERS = [
  { color: ERROR_COLOR, bg: ERROR_BG, text: ERROR_TEXT },
  { color: WARNING_COLOR, bg: WARNING_BG, text: '#8A5A00' },
  { color: INFO_COLOR, bg: 'rgba(33, 150, 243, 0.12)', text: '#0B4F8A' },
  { color: SUCCESS_COLOR, bg: SUCCESS_BG, text: SUCCESS_TEXT },
];

export const bandTier = bandIndex => BAND_TIERS[bandIndex] || BAND_TIERS[0];

// DP-detail metric cards, in display order. `type` drives value + trend formatting.
export const DP_METRICS = [
  { key: 'UPB_MATCHED_COUNT', label: 'UPB matched', type: 'int', feature: true },
  { key: 'TOTAL_PRODUCT_COUNT', label: 'Total products', type: 'int' },
  { key: 'TOTAL_ACTIVE_PRODUCT_COUNT', label: 'Active products', type: 'int' },
  { key: 'TOTAL_BRANDED_PRODUCT_COUNT', label: 'Branded', type: 'int' },
  { key: 'TOTAL_PACKER_PRODUCT_COUNT', label: 'Packer', type: 'int' },
  { key: 'PRODUCT_COUNT_WITH_KNOWN_SKU', label: 'Known SKU', type: 'int' },
  { key: 'CLASSIFIED_COUNT', label: 'Classified', type: 'int' },
  { key: 'AVG_P0_SCORE', label: 'Avg P0 score', type: 'score' },
  { key: 'AVG_ATTRIBUTE_SCORE', label: 'Avg attribute score', type: 'score' },
  { key: 'ANNUALIZED_GMV', label: 'Annualized GMV', type: 'usd', feature: true },
];

// Trend range options (default first). 3 months is the stats retention cap.
export const TREND_RANGES = [
  { value: '7d', label: 'Last 7 days' },
  { value: '1m', label: 'Last month' },
  { value: '3m', label: 'Last 3 months' },
];
